import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { WA_SESSION_STORAGE } from '@ng-web-apis/common';
import { Store } from '@ngrx/store';
import { filter, map, Observable, tap } from 'rxjs';

import { FormStep, Status } from '@features/succession/enums';
import { CustomerInformation } from '@features/succession/models';
import * as fromStore from '@features/succession/store';

const checkStore = (request: CustomerInformation, store: Store): Observable<string> =>
  store.select(fromStore.selectCustomerInformationLoadStatus).pipe(
    tap((status: string) => {
      if (status === Status.INITIAL) {
        store.dispatch(fromStore.CustomerInformationInitializing({ customerInformation: request }));
      }
    }),
  );
export const CustomerInformationGuard = (route: ActivatedRouteSnapshot): Observable<boolean> => {
  const store = inject(Store);
  const storageService = inject(WA_SESSION_STORAGE);

  const request: CustomerInformation = {
    token: storageService?.getItem('ia-succession-token') || '',
    savePage: storageService?.getItem('ia-succession-token')
      ? route.data['savePage']
      : FormStep.ZERO,
    loadPage: route.data['loadPage'],
    deceasedInformations: undefined,
    deceasedMoreInformations: undefined,
    reporterInformations: undefined,
    notaryInformations: undefined,
    inheritanceInformations: undefined,
  };

  return checkStore(request, store).pipe(
    filter((status) => status !== Status.INITIAL),
    filter((status) => status !== Status.PROCESSING),
    map(() => true),
  );
};
